import Vue from 'vue'
import Router from 'vue-router'
import RouterConfig from './modules' // 引入业务逻辑模块
import CommonRouters from './common' // 引入通用模块

Vue.use(Router)


// 捕获push replace中的错误
// 当然在replace中的错误也是可以相同的进行捕获
const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace
// push
Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}
// replace
Router.prototype.replace = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
    return originalReplace.call(this, location).catch(err => err)
}


export default new Router({
    mode: 'history',
    routes: RouterConfig.concat(CommonRouters),
    scrollBehavior(to, from, savedPosition) {
        Boolean(document.querySelectorAll(".el-scrollbar__wrap")[0]) ? (document.querySelectorAll(".el-scrollbar__wrap")[0].scrollTop = 0) : ''
        return { x: 0, y: 0 }
    }
})
